//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ClassFunc = require('../../../util/ClassFunc')
const Stats = require('./Stats')

/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_icehockey_PlayerStatsSummary = function() {
    // console.log('tbs_model_vo_icehockey_PlayerStatsSummary constructor')
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Stats, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_icehockey_PlayerStatsSummary.prototype = {
    /* The view object name */
    name: 'summary',
    /* The view object instance */
    view: {
        get: [
            {
                name: 'seasons',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/seasons/option',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                },
                basePath: '',
                rule: {
                    text: '~season',
                    value: '~season',
                }
            },
            {
                name: 'leagues',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/leagues/option',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    season: 'season',
                },
                basePath: '',
                rule: {
                    text: 'leagueName',
                    value: '~leagueId',
                }
            },
            {
                name: 'groups',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/groups/option',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    season: 'season',
                    league: 'league',
                },
                basePath: '',
                rule: {
                    text: 'groupName',
                    value: '~groupId',
                }
            },
            {
                name: 'stats',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/stats/:role/1',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    role: 'role',
                    season: 'season',
                    league: 'league',
                    group: 'group'
                },
                basePath: '0',
                rule: {
                    cgp: 'cgp',
                    g: 'g',
                    a: 'a',
                    p: 'p',
                    pim: 'pim',
                    gaa: '$gaa',
                    w: 'w',
                    l: 'l',
                    wp: '$wp',
                    so: 'so',
                }
            },
            {
                name: 'rankings',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/rankings',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    season: '#season',
                    league: '#league',
                    group: '#group'
                },
                basePath: '',
                rule: {
                    indicator: 'indicator',
                    rank: 'rank',
                }
            },
        ],
        promo: [
            {
                name: 'stats',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/stats/:role/3',
                method: 'get',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    role: 'role'
                },
                basePath: '0',
                rule: {
                    season: 'season',
                    cgp: 'cgp',
                    g: 'g',
                    a: 'a',
                    p: 'p',
                    pim: 'pim',
                    gaa: '$gaa',
                    w: 'w',
                    l: 'l',
                    wp: '$wp',
                    so: 'so',
                }
            },
            {
                name: 'rankings',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/rankings/3',
                method: 'get',
                query: {
                    passport: 'passport',
                    id: 'playerId',
                    season: '^0.data.payload.0.season',   // use the object path for the variable value
                },
                basePath: '',
                rule: {
                    indicator: 'indicator',
                    rank: 'rank',
                },
                seq: true,    // use the seq flag with true for the flow request
            },
        ]
    },
}

//--------------------------------------------------
// extends the Stats
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_icehockey_PlayerStatsSummary, Stats)

module.exports = tbs_model_vo_icehockey_PlayerStatsSummary